(function ($) {
  $(document).ready(function () {
    if ($(".resource-grid").length > 0) {
      setTimeout(function () {
        $(".resource-grid .column-wrapper").css({opacity: "1"});
      }, 500);
      if ($(".resource-grid.carousel .column-wrapper .col-three").length > 3) {
        $(".resource-grid.carousel .column-wrapper").slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                draggable: true,
              },
            },
            {
              breakpoint: 595,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      }
    }
  });
})(jQuery);